const APP_CONFIG = {
	QUERY_STALE_TIME: 30_000,
	QUERY_CACHE_TIME: 1_800_000,
	QUERY_RETRY: 2,
	HEADER_HEIGHT: 70,
	TABLE_PAGE_SIZES: [15, 50, 100],
	DEFAULT_LANGUAGE: 'PL',
	ADMIN_DEFAULT_ROLE_ID: crypto.randomUUID(),
	DESCRIPTION_MAX_LENGTH: 1000,
	SESSION_STORAGE_KEYS: {
		REFRESH_TOKEN: 'refreshToken',
		PRODUCT_TYPES: {
			PAGE: 'product_types-page',
			LIMIT: 'product_types-limit',
			SEARCH: 'product_types-search',
			SORT: 'product_types-sort',
		},
		USERS: {
			PAGE: 'users-page',
			LIMIT: 'users-limit',
			SEARCH: 'users-search',
			SORT: 'users-sort',
		},
		CONTENT: {
			PAGE: 'content-page',
			LIMIT: 'content-limit',
			SEARCH: 'content-search',
			SORT: 'content-sort',
		},
		NOTIFICATIONS: {
			PAGE: 'notifications-page',
			LIMIT: 'notifications-limit',
			SEARCH: 'notifications-search',
			SORT: 'notifications-sort',
		},
		PRODUCTS: {
			PAGE: 'products-page',
			LIMIT: 'products-limit',
			SEARCH: 'products-search',
			SORT: 'products-sort',
		},
	},
	AVAILABLE_COUNTRIES: [
		'Polska',
		'Deutschland',
		'United Kingdom',
		'Česká republika',
		'Slovensko',
		'France',
	],
} as const;

export default APP_CONFIG;
